jQuery(document).ready(function() {
	var popupElement = jQuery('#popup');

	if (popupElement.length > 0) {
		var popupModal = new Foundation.Reveal(popupElement);

		setTimeout(function() {
			jQuery('#popup').foundation('open');
		}, 0);
	}
});
